import ListingImage from '@Components/Listings/ListingImage';
import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';
import { truncateString, formatPrintPageDate } from '@Components/Utilities/SandhillsUtility';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
const RentalAndLeasePrices = loadable(() => import('@Components/Shared/RentalAndLeasePrices'));

const PrintWebListing = (props) => {

    const linkTarget = '_blank';
    return (
        <div className='print-listing-container'>
            <div className='print-listing-left'>
                <ListingImage ListingId={props.Id} AbsolutePathBaseUrl={props.AbsolutePathBaseURL} DetailUrl={props.DetailUrl} LinkTarget={linkTarget} LazyLoad={props.LazyLoad} {...props.ListingImageModel}
                    ListingTitle={props.ListingTitle} ForceLoadImages={props.ForceLoadImages} DispatchListings={props.DispatchListings} IsPrintEventSaleCatalog={props.IsPrintEventSaleCatalog} IsPrintListPage={props.IsPrintListPage}
                ></ListingImage>
            </div>
            <div className='print-listing-middle'>
                <div className='list-listing-title' data-score={props.ElasticScore}>
                    {props.LotNumber && <div className='lot-number'>{translator.translate('sandhills.auctiontime.api.lotnumber') + ': ' + props.LotNumber}</div>}
                    {props.DetailUrl && props.ListingTitle ? (
                        <h2 className="listing-portion-title">
                            <a href={props.DetailUrl} className='list-listing-title-link' target={linkTarget}>
                                {props.ListingTitle}
                                <span className='visually-hidden'>({translator.translate('sandhills.opensinanewtab')})</span>
                            </a>
                            {" "}
                            <span className='listing-category' dangerouslySetInnerHTML={{ __html: props.DisplayCategoryName }} />
                        </h2>
                    ) : (
                        <h2 className="listing-portion-title">
                            {props.ListingTitle}
                            {" "}
                            <span className='listing-category' dangerouslySetInnerHTML={{ __html: props.DisplayCategoryName }} />
                        </h2>
                    )}
                </div>
                <div className='listing-category'>{props.DisplayCategoryName}</div>
                <div className='specs-container'>
                    {props.Specs && props.Specs.slice(0, 4).map((l, i) =>
                        <div key={i} className='spec-container'>
                            <span className='spec-label'>{l.Key}:</span><span className='spec-value'>{truncateString(l.Value, props.ListPageSpecMaxLength)}</span>
                        </div>)}
                </div>
                {props.Description && props.Description.trim() !== '' &&
                    <div>
                        <p className='print-listing-description-text'>
                            <span className='print-listing-description'>
                                {props.Description.length > props.ListPageDescriptionMaxLength ?
                                    <>
                                        {truncateString(props.Description, props.ListPageDescriptionMaxLength)}
                                    </>
                                    :
                                    <>{props.Description}</>}
                            </span>
                        </p>
                    </div>}
            </div>
            <div className='print-listing-right'>

                {(!props.IsAT && !props.IsEF && props.Dealer) && <div><span className='spec-label'> <TranslationText tKey='sandhills.dealer' />:</span><span className='spec-value'>{props.Dealer}</span></div>}

                {props.DealerLocation && <div><span className='spec-label'>
                    {props.CurrentSite?.Site?.IsAuctionTime
                        ? <TranslationText tKey='sandhills.auctioneerlocation' />
                        : <TranslationText tKey='sandhills.tradepubwebsite.mvc.sellerlocation' />}:
                </span><span className='spec-value'>{props.DealerLocation}</span></div>}

                {props.ListingLocation?.FormattedLocation && <div><span className='spec-label'> <TranslationText tKey='sandhills.location' />: </span><span className='spec-value'>{props.ListingLocation.FormattedLocation}</span></div>}

                {props.WebEndDateTime && props.CurrentSite?.Site?.IsAuctionTime &&
                    <>
                        {props.IsAuctionResult ?
                        <div><span className='spec-label'> <TranslationText tKey='sandhills.tradesites.mvc.auctionended' />:</span> <span className='spec-value'>{formatPrintPageDate(props.WebEndDateTime)}</span></div>
                        :
                            <div><span className='spec-label'> <TranslationText tKey='sandhills.enddate' />:</span> <span className='spec-value'> {formatPrintPageDate(props.WebEndDateTime)}</span></div>
                        }
                    </>
                    }

                {props.CurrentSite?.Site?.IsRentalYard ?
                    <>
                        {props.PriceGroup && props.PriceGroup.length > 0 &&
                            <div className = "rental-yard-print"><RentalAndLeasePrices PriceGroup={props.PriceGroup} /></div>
                            
                        }
                    </>
                    :
                    <>
                        {props.IsAuctionResult ?
                            <>
                                {props.ShowAuctionResults ?
                                    <>
                                        <div><span className='spec-label'>{props.PriceLabel}:</span><span className='spec-value'>{props.RetailPrice}</span></div>
                                    </>
                                    :
                                    <>
                                        <div><span className='spec-label'>{props.PriceLabel}:</span><span className='spec-value'><TranslationText tKey='sandhills.loginorregistertoviewauctionresults' /></span></div>
                                    </>
                                }
                            </>
                            :
                            <>
                                {props.AuctionBiddingData || (props.IsAT || props.IsEF) ?
                                    <>
                                        <div><span className='spec-label'><TranslationText tKey='sandhills.currentbid' />: </span><span className='spec-value'>{props.AuctionBiddingData?.CurrentBidFormatted}</span></div>

                                    </>
                                    :
                                    <>

                                        {props.RetailPhoneNumber && <div><span className='spec-label'><TranslationText tKey='sandhills.phone' />: </span><span className='spec-value'>{props.RetailPhoneNumber}</span></div>}

                                        {props.RetailPrice && <div><span className='spec-label'>{props.PriceLabel}:</span><span className='spec-value'>{props.RetailPrice}</span></div>}

                                        {props.AlternateRetailPrice && <div><span className='spec-label'>{props.PriceLabel}:</span><span className='spec-value'>{props.AlternateRetailPrice}</span></div>}


                                    </>}
                            </>
                        }
                    </>
                }

            </div>
        </div>
    );
};

export default PrintWebListing;